/* eslint-disable jsx-a11y/control-has-associated-label */
import * as PropTypes from "prop-types"
import React, { memo } from "react"
import ReactMarkdown from "react-markdown"

import Navigation from "./Navigation"
import { isUrl } from "../helpers"
import Facebook from "../assets/leovegasplay/facebook.png"
import Instagram from "../assets/leovegasplay/instagram.png"

const Footer = ({ footerInfo, logo, isItaly }) => {
  const { footerNavigationItems, copyright, licenceLogo, footerDisclaimer, footerLogos } = footerInfo
  return (
    <footer className="page__footer">
      <div className="logos">{logo && <img src={logo} alt="logo" />}</div>
      <div className="page__inner flex-space-between">
        <Navigation list={footerNavigationItems} modifier="small" isFooter />
      </div>
      <div className="page__inner">
        {licenceLogo && (
          <a
            href="https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=726b906b-4fe8-4cf9-9294-0a6a8a808d90&details=1"
            target="_blank"
            rel="noreferrer"
          >
            <img src={licenceLogo} alt="licence logo" width="100%" height="100%" />
          </a>
        )}
        <hr style={{ margin: "0 auto 30px", opacity: "0.1" }} />
        {isItaly && (
          <>
            <div className="socials">
              <p>Seguici su:</p>
              <div className="icons">
                <a href="https://www.instagram.com/leovegasplay/" rel="noreferrer" target="_blank">
                  <img alt="logo Instagram" src={Instagram} width="100%" height="70px" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=61579198045293" rel="noreferrer" target="_blank">
                  <img alt="logo Facebook" src={Facebook} width="100%" height="100%" />
                </a>
              </div>
            </div>
            <hr style={{ margin: "0 auto 30px", opacity: "0.1" }} />
          </>
        )}
        <div className="disclaimer">
          <ReactMarkdown>{footerDisclaimer}</ReactMarkdown>
        </div>
        {footerLogos && (
          <div className="logos">
            {footerLogos.map((item, index) => {
              const key = index
              const { attributes, name } = item

              if (isUrl(attributes?.url)) {
                return (
                  <div key={key}>
                    <a href={attributes?.url}>
                      <img alt={name} key={key} src={attributes?.icon} width="100%" height="100%" />
                    </a>
                  </div>
                )
              }

              return (
                <div key={key}>
                  <img alt={name} src={attributes?.icon} width="100%" height="100%" />
                </div>
              )
            })}
          </div>
        )}
        <p className="copyright">{copyright}</p>
      </div>
    </footer>
  )
}

Footer.propTypes = {
  footerInfo: PropTypes.objectOf(PropTypes.any).isRequired,
  logo: PropTypes.string,
  isItaly: PropTypes.bool
}

Footer.defaultProps = {
  logo: null,
  isItaly: false
}

export default memo(Footer)
